module.exports = __webpack_public_path__ + "img/order-confirmed.9a3876ec.png";